var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUptimeMonitorInfoAlertImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 110,
    viewBox: "0 0 126 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110.489 110H14.6667C6.58142 110 0 103.422 0 95.3333C0 92.7158 0.7018 90.1377 2.03378 87.8819L49.9449 7.2116C52.5732 2.76442 57.4144 0 62.5778 0C67.7412 0 72.5824 2.76442 75.2107 7.2116L123.122 87.8783V87.8819C124.454 90.1379 125.156 92.7158 125.156 95.3333C125.156 103.422 118.574 110 110.489 110Z",
    fill: "url(#paint0_linear_4872_39623)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.578 76.9999C58.5317 76.9999 55.2446 80.2906 55.2446 84.3333C55.2446 88.3759 58.5317 91.6666 62.578 91.6666C66.6243 91.6666 69.9113 88.3759 69.9113 84.3333C69.9113 80.2906 66.6243 76.9999 62.578 76.9999ZM58.9399 62.7879C59.1692 64.6213 60.7302 65.9999 62.578 65.9999C64.4257 65.9999 65.9867 64.6213 66.216 62.7879L69.8827 33.4546C70.0115 32.4125 69.6893 31.3599 68.9946 30.5721C68.2999 29.7843 67.2975 29.3333 66.2446 29.3333H58.9113C57.8585 29.3333 56.856 29.7845 56.1613 30.5721C55.4666 31.3597 55.1444 32.4125 55.2732 33.4546L58.9399 62.7879Z",
    fill: "url(#paint1_linear_4872_39623)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_39623",
    x1: 62.5778,
    y1: 110,
    x2: 62.5778,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4872_39623",
    x1: 62.578,
    y1: 91.6666,
    x2: 62.578,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptimeMonitorInfoAlertImage);
export default __webpack_public_path__ + "static/media/uptimeMonitorInfoAlertImage.cf0019182a97311c024edb099d811f91.svg";
export { ForwardRef as ReactComponent };